"use strict";

exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Response = function () {
    function Response(_ref) {
        var status = _ref.status,
            statusText = _ref.statusText,
            ok = _ref.ok,
            headers = _ref.headers,
            body = _ref.body;

        _classCallCheck(this, Response);

        this.status = status;
        this.statusText = statusText;
        this.ok = ok || status >= 200 && status < 300;
        this.headers = new Headers(headers || {});
        this.body = body;
    }

    Response.prototype.createResponseEntity = function createResponseEntity() {
        return {
            ok: this.ok,
            status: this.status,
            statusText: this.statusText,
            body: this.body
        };
    };

    return Response;
}();

exports["default"] = Response;
module.exports = exports["default"];